/* template */
<template><page><base-container><cube-segment-city-picker></cube-segment-city-picker><div :class='["picker-divider-wrapper"]'><cube-divider></cube-divider></div><cube-segment-date-picker></cube-segment-date-picker></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_192e8e0e"}'>
.picker-divider-wrapper
  margin 10px 0
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_192e8e0e"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_192e8e0e"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_192e8e0e"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-segment-date-picker':getComponent(require("./segment-date-picker.mpx?isComponent&outputPath=components%2Fsegment-date-picker2dc57bef%2Findex")),'cube-segment-city-picker':getComponent(require("./segment-city-picker.mpx?isComponent&outputPath=components%2Fsegment-city-picker7cb94a12%2Findex")),'cube-divider':getComponent(require("../../../packages/mpx-cube-ui/src/components/divider/index.mpx?isComponent&outputPath=components%2Findex731ea706%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>